<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div class="px-4 pt-1 pb-2 d-flex flex-column flex-md-row justify-md-end">
        <v-btn
          class="btn-edit rounded-lg mb-3 mb-md-0 ml-md-2 mx-0" 
          :block="$vuetify.breakpoint.smAndDown"
          @click="showTemplatesDialog = true"
        >
          <v-icon right class="ml-2">mdi-palette-swatch</v-icon>
          نمونه‌های آماده
        </v-btn>
        
        <v-btn
          class="btn-upload rounded-lg mb-3 mb-md-0 ml-md-2 mx-0"
          :block="$vuetify.breakpoint.smAndDown"
          @click="setBlackAndWhite"
          outlined
        >
          <v-icon right class="ml-2">mdi-qrcode</v-icon>
          سیاه و سفید
        </v-btn>
      </div>

      <qr-code-templates 
        v-model="showTemplatesDialog" 
        @select="applyTemplate" 
      />
      <v-expansion-panels class="pa-4" flat>
        <v-expansion-panel v-for="(item, i) in panels" :key="i" class="mb-4">
          <v-expansion-panel-header class="text-right px-9 py-6" >
            <div
              class="d-flex row justify-start algin-center"
              style="align-items: center !important"
            >
              <v-icon class="me-2">mdi-{{ item.icon }}</v-icon>
              {{ item.title }}
              <help-info
                :element-name="`${serviceName}-${componentName}-${i}`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="`${item.title}`"
              />
            </div>
          </v-expansion-panel-header>

          <v-expansion-panel-content class="py-5">
            <component
              :is="item.name"
              v-model="options"
              :colors="colors"
              @update="updateStyle"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
  </help-info-wrapper>
</template>

<script>
import QRCodeStyling from "qr-code-styling";
import { debounce } from "@/main";
import QrCodeData from "@/view/pages/qrland/qrCodeStyle/components/qrCodeData";
import QrCodeLogo from "@/view/pages/qrland/qrCodeStyle/components/qrCodeLogo";
import QrCodeDots from "@/view/pages/qrland/qrCodeStyle/components/qrCodeDots";
import QrCodeEye from "@/view/pages/qrland/qrCodeStyle/components/qrCodeEye";
import QrCodeOptions from "@/view/pages/qrland/qrCodeStyle/components/qrCodeOptions";
import QrCodeSquare from "./components/qrCodeSquare";
import QrCodeTemplates from "@/view/pages/qrland/qrCodeStyle/components/QrCodeTemplates"; 

let qrCode = null;
export default {
  name: "qrCodeMake",

  components: {
    QrCodeOptions,
    QrCodeSquare,
    QrCodeEye,
    QrCodeDots,
    QrCodeData,
    QrCodeLogo,
    QrCodeTemplates
  },

  props: {
    value: Object,
    canvasId: String,
    file: String,
    link: String,
  },

  data: () => ({
    showTemplatesDialog: false, 
    helpData: [],
    serviceName: "Qrland",
    componentName: "qrCodeMake",
    options: {
      width: 300,
      height: 300,
      data: "https://qr2.in",
      margin: 5,
      qrOptions: {
        typeNumber: 0,
        mode: "Byte",
        errorCorrectionLevel: "H",
      },
      imageOptions: {
        hideBackgroundDots: true,
        imageSize: 0.4,
        margin: 0,
      },
      dotsOptions: {
        type: "extra-rounded",
        color: "#6a1a4c",
        gradient: {
          type: "linear",
          rotation: 0,
          colorStops: [
            { offset: 0, color: "#933490" },
            { offset: 1, color: "#933490" },
          ],
        },
      },
      backgroundOptions: { color: "#FFFFFFFF" },
      image: null,
      dotsOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#6a1a4c",
          color2: "#6a1a4c",
          rotation: "0",
        },
      },
      cornersSquareOptions: {
        type: "extra-rounded",
        color: "#690a70",
        gradient: {
          type: "linear",
          rotation: 0,
          colorStops: [
            { offset: 0, color: "#690a70" },
            { offset: 1, color: "#690a70" },
          ],
        },
      },
      cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#000000",
          color2: "#000000",
          rotation: "0",
        },
      },
      cornersDotOptions: {
        type: "",
        color: "#b00cab",
        gradient: {
          type: "linear",
          rotation: 0,
          colorStops: [
            { offset: 0, color: "#b00cab" },
            { offset: 1, color: "#b00cab" },
          ],
        },
      },
      cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#000000",
          color2: "#000000",
          rotation: "0",
        },
      },
      backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#ffffff",
          color2: "#ffffff",
          rotation: "0",
        },
      },
    },
    colors: [
      ["#649173", "#DBD5A4"],
      ["#B993D6", "#8CA6DB"],
      ["#870000", "#190A05"],
      ["#00d2ff", "#3a7bd5"],
      ["#DAD299", "#B0DAB9"],
      ["#E6DADA", "#274046"],
      ["#50C9C3", "#96DEDA"],
      ["#4b6cb7", "#182848"],
      ["#EC6F66", "#F3A183"],
      ["#5f2c82", "#49a09d"],
    ],
  }),

  async mounted() {
    this.options.data = this.link || "";
    qrCode = new QRCodeStyling(this.computedValue);
    if (!!this.value && !!Object.keys(this.value).length) {
      let keys = Object.keys(this.value);
      if (
        keys.includes("imageOptions") &&
        keys.includes("qrOptions") &&
        keys.includes("dotsOptions") &&
        keys.includes("backgroundOptions") &&
        keys.includes("cornersSquareOptions") &&
        keys.includes("cornersDotOptions")
      ) {
        this.options = { ...this.value, data: this.link || this.value.data };
        // this.options = this.value;
      } else {
        await this.ranColor();
        this.updateStyle();
        this.$emit("input", this.options);
        this.$emit("save", this.options);
      }
    } else {
      await this.ranColor();
      this.updateStyle();
      this.$emit("input", this.options);
      this.$emit("save", this.options);
    }
  },

  computed: {
    panels() {
      return [
        {
          name: "QrCodeData",
          title: this.$t("qr_color_size"),
          icon: "qrcode-edit",
        },
        {
          name: "QrCodeDots",
          title: this.$t("dots_design_color"),
          icon: "dots-triangle",
        },
        {
          name: "QrCodeEye",
          title: this.$t("eye_design_color"),
          icon: "bullseye",
        },
        {
          name: "QrCodeSquare",
          title: this.$t("border_design_color"),
          icon: "rounded-corner",
        },
        {
          name: "QrCodeLogo",
          title: this.$t("logo_settings"),
          icon: "pig-variant-outline",
        },
        { name: "QrCodeOptions", title: this.$t("qr_settings"), icon: "cogs" },
      ];
    },
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    setBlackAndWhite() {
      // ۱. پس‌زمینه (سفید خالص و حذف قطعی گرادیانت احتمالی پس‌زمینه)
      if (this.options.backgroundOptions) {
        this.$set(this.options.backgroundOptions, 'color', '#FFFFFFFF');
        this.$set(this.options.backgroundOptions, 'gradient', null);
      }

      // ۲. نقطه‌ها (مشکی خالص و فورس کردن کتابخانه به حذف گرادیانت با پاس دادن null)
      if (this.options.dotsOptions) {
        this.$set(this.options.dotsOptions, 'color', '#000000');
        this.$set(this.options.dotsOptions, 'gradient', null);
      }

      // ۳. چشم‌ها - فریم خارجی
      if (this.options.cornersSquareOptions) {
        this.$set(this.options.cornersSquareOptions, 'color', '#000000');
        this.$set(this.options.cornersSquareOptions, 'gradient', null);
      }

      // ۴. چشم‌ها - نقطه داخلی
      if (this.options.cornersDotOptions) {
        this.$set(this.options.cornersDotOptions, 'color', '#000000');
        this.$set(this.options.cornersDotOptions, 'gradient', null);
      }

      // ۵. آپدیت هلپرهای رابط کاربری (تغییر وضعیت سوییچ‌ها به رنگ سالید در UI)
      const helpers = [
        "dotsOptionsHelper",
        "cornersSquareOptionsHelper",
        "cornersDotOptionsHelper",
        "backgroundOptionsHelper"
      ];
      
      helpers.forEach(helper => {
        if (this.options[helper] && this.options[helper].colorType) {
          this.$set(this.options[helper].colorType, 'single', true);
          this.$set(this.options[helper].colorType, 'gradient', false);
        }
      });

      // ۶. اجرای آپدیت نهایی
      this.updateStyle(true);
    },

     applyTemplate(template) {
      this.options = {
        ...this.options,
        dotsOptions: { ...this.options.dotsOptions, ...template.config.dotsOptions },
        cornersSquareOptions: { ...this.options.cornersSquareOptions, ...template.config.cornersSquareOptions },
        cornersDotOptions: { ...this.options.cornersDotOptions, ...template.config.cornersDotOptions },
        backgroundOptions: { ...this.options.backgroundOptions, ...template.config.backgroundOptions },
      };
      if (this.options.dotsOptionsHelper) {
        this.options.dotsOptionsHelper.colorType.single = true;
        this.options.dotsOptionsHelper.colorType.gradient = false;
      }
      if (this.options.cornersSquareOptionsHelper) {
        this.options.cornersSquareOptionsHelper.colorType.single = true;
        this.options.cornersSquareOptionsHelper.colorType.gradient = false;
      }

      this.updateStyle(true);
    },
    appendCanvas(url) {
      if (!url) return;
      // this.options.data = url;
      this.options = { ...this.options, data: url };
      qrCode.append(document.getElementById(this.canvasId ?? "canvas-wrapper"));
      this.updateStyle();
      this.$emit("input", this.options);
      this.$emit("save", this.options);
    },
    updateStyle(timer = false, options = this.options) {
      this.$nextTick(() => {
        debounce(
          () => {
            try {
              qrCode.update(this.options);
              this.getDataUrl();
              this.$emit("input", this.options);
              this.$emit("save", this.options);
            } catch (e) {}
          },
          !!timer ? 500 : 0,
        );
      });
    },
    async getDataUrl(type = "svg") {
      try {
        let blob = await qrCode.getRawData(type);
        if (!blob) {
          console.error("Failed to get QR code blob");
          return;
        }
        const reader = new FileReader();
        reader.addEventListener("loadend", () => {
          this.$emit("update:file", reader.result);
        });
        reader.readAsDataURL(blob);
      } catch (error) {}
    },
    ranColor() {
      return new Promise((resolve) => {
        let rand = this.colors[Math.floor(Math.random() * 10)];
        this.options.dotsOptions.gradient.colorStops = [
          { offset: 0, color: rand[0] },
          { offset: 1, color: rand[1] },
        ];
        resolve("resolve");
      });
    },
  },
};
</script>

<style scoped>
#canvas-wrapper >>> canvas {
  max-width: 100%;
  max-height: 300px;
}

.v-expansion-panel {
  border-radius: 15px !important;
  box-shadow: 8px 5px 10px #f49d1a;
}

.v-expansion-panel
  >>> .v-expansion-panel-header.v-expansion-panel-header--active {
  background-color: #001554 !important;
  border-radius: 15px !important;
  color: whitesmoke !important;
}

.v-expansion-panel
  >>> .v-expansion-panel-header.v-expansion-panel-header--active
  .v-icon {
  color: whitesmoke !important;
}
</style>
